import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const Contact = () => {
    const [name, setName] = useState(""); const [email, setEmail] = useState(""); const [message, setMessage] = useState("");
    const [sending, setSending] = useState(false);
    const submit = async (e) => {
        e.preventDefault();
        if (!name || !email || !message) return toast.error("A few details, please");
        setSending(true);
        try {
            const r = await api.post("/contact", { name, email, message });
            toast.success("Thank you", { description: r.data.message });
            setName(""); setEmail(""); setMessage("");
        } catch { toast.error("Please try again"); }
        finally { setSending(false); }
    };
    return (
        <div className="max-w-2xl mx-auto px-6 py-20" data-testid="contact-page">
            <div className="text-center mb-12">
                <div className="small-caps text-xs text-muted-foreground mb-3">Write us</div>
                <h1 className="font-serif text-4xl md:text-5xl">Contact</h1>
            </div>
            <form onSubmit={submit} className="missal-card p-8 space-y-4">
                <input value={name} onChange={e => setName(e.target.value)} placeholder="Your name" data-testid="c-name" className="w-full bg-transparent border border-border px-4 py-3 focus:outline-none focus:border-liturgy" />
                <input value={email} onChange={e => setEmail(e.target.value)} type="email" placeholder="Email" data-testid="c-email" className="w-full bg-transparent border border-border px-4 py-3 focus:outline-none focus:border-liturgy" />
                <textarea value={message} onChange={e => setMessage(e.target.value)} rows={6} placeholder="Your message" data-testid="c-msg" className="w-full bg-transparent border border-border px-4 py-3 focus:outline-none focus:border-liturgy" />
                <button disabled={sending} data-testid="c-submit" className="w-full py-3 bg-liturgy text-white small-caps disabled:opacity-40">{sending ? "Sending…" : "Send"}</button>
            </form>
        </div>
    );
};
export default Contact;
